import { render } from "./ViewChannelMaintenance.vue?vue&type=template&id=71ba746f&scoped=true"
import script from "./ViewChannelMaintenance.vue?vue&type=script&lang=js"
export * from "./ViewChannelMaintenance.vue?vue&type=script&lang=js"

import "./ViewChannelMaintenance.vue?vue&type=style&index=0&id=71ba746f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ba746f"]])

export default __exports__